
export const _syllabus = {
  syllabus: [
    { id: "1", status: false, title: 'Earth', chapter: 'Chapter-A' },
    { id: "2", status: false, title: 'Our Solar System', chapter: 'Chapter-B' },
    { id: "3", status: true, title: 'Heat Work & Energy', chapter: 'Chapter-C' },
    { id: "4", status: false, title: 'Electro Magnetism', chapter: 'Chapter-D' },
    { id: "5", status: false, title: 'Digital Electronics', chapter: 'Chapter-E' },
  ]
}

export const getAlphabetByIndex = (index) => {
  const alphabets = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

  if (index >= 0 && index < alphabets.length) {
    return alphabets[index];
  } else {
    return 'Invalid index';
  }
}

export const _chapterPreData = {
  chapterPreData: [
    { id: "1", topic: 'topic-1', learning: 1, quizLevel1: 0, quizLevel2: 0, Results: '' },
    { id: "2", topic: 'topic-2', learning: 0, quizLevel1: 2, quizLevel2: 1, Results: '' },
    { id: "3", topic: 'topic-3', learning: 2, quizLevel1: 1, quizLevel2: 3, Results: '' },
    { id: "4", topic: 'topic-4', learning: 3, quizLevel1: 3, quizLevel2: 2, Results: '' },
    { id: "5", topic: 'topic-5', learning: 4, quizLevel1: 4, quizLevel2: 4, Results: '' },
  ]
}

export const _chapterPostData = {
  chapterPostData: [
    { id: "1", topic: 'topic-1', learning: 1, quizLevel1: 0, quizLevel2: 0, quizLevel3: 0, Results: "" },
    { id: "2", topic: 'topic-2', learning: 0, quizLevel1: 2, quizLevel2: 1, quizLevel3: 0, Results: "" },
    { id: "3", topic: 'topic-3', learning: 2, quizLevel1: 1, quizLevel2: 3, quizLevel3: 0, Results: 3 },
    { id: "4", topic: 'topic-4', learning: 3, quizLevel1: 3, quizLevel2: 2, quizLevel3: 0, Results: "" },
    { id: "5", topic: 'topic-5', learning: 4, quizLevel1: 4, quizLevel2: 4, quizLevel3: 0, Results: "" },
  ]
}

// export const _unitsData = {
//   data: [
//     {
//       id: "1",
//       index: 1,
//       title: "Test Unit 2",
//       chapters:
//         [
//           {
//             id: 1,
//             index: 1,
//             title: "Test Chapter A",
//             status: "Active",
//             is_post_learning_enabled: true, is_locked: "no"
//           },
//           {
//             id: 2,
//             index: 2,
//             title: "Test Chapter B ",
//             status: "Active",
//             is_post_learning_enabled: false, is_locked: "no"
//           },
//           {
//             id: 3,
//             index: 3,
//             title: "Test Chapter C",
//             status: "Active",
//             is_post_learning_enabled: true, is_locked: "no"
//           },
//         ]
//     }
//   ]
// }

export const studentLearningStatus = {
  _data: [
    { firstName: 'john', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'jack', attemptscompleted: 2, status: 'Completed' },
    { firstName: 'robin', attemptscompleted: 4, status: 'Completed' },
    { firstName: 'mike', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'ben', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'yon', attemptscompleted: 1, status: 'Completed' },
  ]
}

export const studentQuizStatus = {
  _data: [
    { firstName: 'john', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'jack', attemptscompleted: 2, quizstatus: 'fail' },
    { firstName: 'robin', attemptscompleted: 4, quizstatus: 'pass' },
    { firstName: 'mike', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'ben', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'yon', attemptscompleted: 1, quizstatus: 'pass' },
  ]
}

export const studentPreLearningStatus = {
  _data: [
    { firstName: 'stu1', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'stu2', attemptscompleted: 2, status: 'Completed' },
    { firstName: 'stu3', attemptscompleted: 4, status: 'Completed' },
    { firstName: 'stu4', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'stu5', attemptscompleted: 1, status: 'Completed' },
    { firstName: 'stu6', attemptscompleted: 1, status: 'Completed' },
  ]

}

export const studentPreQuizStatus = {
  _data: [
    { firstName: ' wick', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'kio', attemptscompleted: 2, quizstatus: 'fail' },
    { firstName: 'neo', attemptscompleted: 4, quizstatus: 'pass' },
    { firstName: 'mike', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'ben', attemptscompleted: 1, quizstatus: 'pass' },
    { firstName: 'yon', attemptscompleted: 1, quizstatus: 'pass' },
  ]
}


export const Common = {
  GSTRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  questionBlankRegex: /(\$\$)(.*?)(\$\$)/g,
  max200Char: 'comment should contain maximum 200 characters!',
  forgotPassword: 'Forgot Password?',
  alphabetsRegex: `^(?=.*[a-zA-Z])[a-zA-Z]+$`,
  // UserNameRegex: /^([a-zA-Z]+\s)*[a-zA-Z]+$/, //accepts numbers
  UserNameRegex: /^[a-zA-Z ]+$/, //accepts numbers
  AlphaNumaricRegex: '[A-Za-z0-9_]',
  PassportRegex: `^[A-PR-WYa-pr-wy][1-9]\\d\\s?\\d{4}[1-9]$`,
  PanRegex: '[A-Z]{5}[0-9]{4}[A-Z]{1}',
  DLregex: /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
  AadhaarCardRegex: /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/,
  VoterIdRegex: '^([a-zA-Z]){3}([0-9]){7}?$',
  TelephoneNumberRegex: '^s*(?:+?(d{1,3}))?[-. (]*(d{3})[-. )]*(d{3})[-. ]*(d{4})(?: *x(d+))?s*$',
  RcBookRegex: '^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$',
  // RcBookRegex: '[A-Z]{2}?[0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$',
  // _RcBookRegex: '^[A-Z]{2}[-][0-9]{1,2}[-][A-Z]{1,2}[-][0-9]{3,4}$',
  _RcBookRegex: '^[A-Z]{2}(-| |)[0-9]{1,2}(-| |)[A-Z]{1,2}(-| |)[0-9]{3,4}$',
  WebsiteRegex: '^(http://www.|https://www.|http://|https://)?[a-z0-9]+([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$',
  // accepts: 18005551234, 1 800 555 1234, +1 800 555-1234, +86 800 555 1234, 1-800-555-1234, 1 (800) 555-1234, (800)555-1234, (800) 555-1234, (800)5551234, 800-555-1234, 800.555.1234, 800 555 1234x5678, 8005551234 x5678, 1    800    555-1234, 1----800----555-1234
  // ^\s*                #Line start, match any whitespaces at the beginning if any.
  // (?:\+?(\d{1,3}))?   #GROUP 1: The country code. Optional.
  // [-. (]*             #Allow certain non numeric characters that may appear between the Country Code and the Area Code.
  // (\d{3})             #GROUP 2: The Area Code. Required.
  // [-. )]*             #Allow certain non numeric characters that may appear between the Area Code and the Exchange number.
  // (\d{3})             #GROUP 3: The Exchange number. Required.
  // [-. ]*              #Allow certain non numeric characters that may appear between the Exchange number and the Subscriber number.
  // (\d{4})             #Group 4: The Subscriber Number. Required.
  // (?: *x(\d+))?       #Group 5: The Extension number. Optional.
  // \s*$                #Match any ending whitespaces if any and the end of string.

  UndefinedObject: undefined,
  Undefined: 'undefined',
  myModal: 'my-modal',
  ActiveProjects: 'Active Projects',
  InvalidOtp: 'Invalid Otp',
  HiIm: "Hi, I'm",
  AboutMe: 'About me',
  IAmCEOFounderOf: 'I am Founder of',
  TheProblemImTryingToSolve: "The Problem I'm trying to solve",
  MyBusinessIsLocatedIn: 'My business is located in',
  YouCanFindUsAt: 'You can find us at',
  MyCurrentProjects: 'My current projects',
  ImLivingIn: `I'm living in`,
  MyProfessionalProfile: 'My Professional Profile',
  MySkills: 'My Skills',
  WhatWeDo: 'What we do',
  TheServicesWeOffer: 'The services we offer',
  WhereWeAreLocated: 'Where we’re located',
  CurrentOffers: 'Current Offers',
  Confirm: 'Confirm',
  Project: 'Project',
  Filter: 'Filter',
  Projects: 'Projects',
  Startups: 'Startups',
  BETAs: 'BETAs',
  Offers: 'Offers',
  InvestYourPassionNow: 'Invest your passion now!',
  JoinBetaToday: 'Join BETA100 today!',
  JoinMeeting: 'Join Meeting',
  ApplicationsSent: 'Applications Sent',
  EmailSent: 'Email Sent Successfully',
  ReviewApplication: 'Review Application',
  RetractApplication: 'Retract Application',
  SignIn: 'Sign In',
  SignOut: 'Sign Out',
  AlreadyHaveAnAccount: 'Already have an account?',
  CreateAnAccount: 'Create an account',
  Table: [
    { name: 'Cash', value: 'cash' },
    { name: 'Equity', value: 'equity' },
    { name: 'Hybrid', value: 'cash and equity' }
  ],
  EquityOfferedWillBe: [
    { name: 'Shares', value: 'shares', tooltip: 'This is when someone owns a specified percentage of your company straight away.' },
    {
      name: 'Stock Options',
      value: 'stock options',
      tooltip:
        'This is when you give someone the opportunity to own shares in your company in the future based on pre-established conditions.'
    }
  ],
  ProjectName: 'Project name',
  TheProblemWeAreSolving: 'The problem we are solving',
  whereYouWillHaveImpact: 'where you’ll have impact',
  thisIsForYouIf: 'this is For You If',
  SkillsWeAreLookingFor: 'Skills we’re looking for',
  levelOfExperienceNeeded: 'level of experience needed',
  duration: 'DURATION',
  commitment: 'COMMITMENT',
  TotalProjectValue: 'Total Project Value',
  BetaProjects: 'BETA Projects',
  BetaHub: 'BETA Hub',
  AboutTheProject: 'About the project',
  AbourOffer: 'About Offer',
  CouponCode: 'Coupon Code',
  AboutStartUp: 'About Start Up',
  ViewProject: 'View Project',
  ViewOffer: 'View Offer',
  ViewProfile: 'View Profile',
  ViewStartUp: 'View Start Up',
  Save: 'Save',
  Delete: 'Delete',
  YesDelete: 'Yes, Delete',
  Publish: 'Publish',
  Close: 'Close',
  Cancel: 'Cancel',
  GotIt: 'Got it!',
  OK: 'OK',
  Yes: 'Y',
  No: 'N',
  _Yes: 'Yes',
  _No: 'No',
  loading: 'loading...',
  ManageProject: 'Manage Project',
  ArchiveProject: 'Archive Project',
  CompleteProject: 'Complete Project',
  TheProblemWeArereSolving: "The problem we're solving",
  WhereYouWillHaveImpact: 'Where you’ll have impact',
  ThisIsForYouIf: 'This is for you if',
  LevelOfExperienceNeeded: 'Level of Experience Needed',
  Duration: 'Duration',
  TheCommitmentRequired: 'The commitment required',
  AboutTheStartup: 'About the Startup',
  BIO: 'BIO',
  ShareThisProject: 'Share This Project',
  PasswordUpdatedSuccessfully: 'password updated successfully!',

  PasswordRegExp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
  PhoneNumberRegExp: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
  // the phone number regex accepts (123) 456-7890, (123)456-7890, 123-456-7890, 123.456.7890, 1234567890, +31636363634, 075-63546725 formats
  UrlRegex:
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  CommaSeperatedValueRegex: `^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$`,
  Decline: 'Decline',
  Accept: 'Accept',
  LetsTalk: "Let's Talk",
  Send: 'Send',
  Hashtag: '',
  CopyLink: 'Copy link',
  Copied: 'Copied!',
  DateFormat_dd_MM_yyyy: 'dd/MM/yyyy',
  DateFormat_DD_MM_YYYY: 'DD/MM/YYYY',
  DateFormat_YYYY_MM_DD: 'YYYY/MM/DD',
  DateFormat_dd_MM_yyyy_hh_mm_a: 'dd/MM/yyyy hh:mm a',
  DateFormat_DD_MM_YYYY_hh_mm_a: 'DD/MM/YYYY hh:mm a',
  TZ_Formate: 'YYYY-MM-DDTHH:mm:ss[Z]',
  TimeFormat_hh_mm_A: 'HH:mm A',
  TimeFormat_hh_mm: 'HH:mm',
  TimeFormat_LT: 'LT',
  QualityOfTheVideoCall: 'Quality of the Video Call',
  ChemistryBetweenYouTwo: 'Chemistry between you two',
  Submit: 'Submit',
  ProjectDecription: 'Project Decription',
  KeyOutcomes: 'Key Outcomes',
  ActivityLog: 'Activity Log',
  BankHours: 'Bank Hours',
  goodFitButtonDisabled: 'good-fit-button-disabled',
  goodFitButtonGreen: 'good-fit-button-green',
  goodFitButton: 'good-fit-button',
  verifyButton: 'verify-button',
  verifyButtonDisabled: 'verify-button-disabled',
  verifyButtonBlue: 'verify-button-blue',
  Disabled: 'disabled',
  InterestedInApplying: 'Interested in Applying?',
  JoinBETA100: 'Join BETA100',
  AlreadyAMember: 'Already a member?',
  ProjectCompletion: 'Project Completion',
  ValueOfBetaBankHours: 'Value of BETA Banked Hours',
  YouCantEditProjectAsBetaAlreadyInvolvedInProject: "You can't edit project as BETA already involved in project",

  IsentItHardToGetTheRightPeopleAroundTheTable: (
    <p className="slide-font-style-1" style={{ textAlign: 'right' }}>
      ISN'T IT HARD TO GET <br />
      THE RIGHT PEOPLE <br />
      AROUND THE TABLE?
    </p>
  ),
  FindPeopleWhoBelieveInTheProblemYouAreSolving: (
    <p className="slide-font-style-2">
      Find people who believe in <br />
      the problem you are solving.
    </p>
  ),
  JoinAsFounder: `JOIN AS FOUNDER`,

  IsWorkNotThaatExcitingAnyMore: (
    <p className="slide-font-style-1">
      IS WORK NOT THAAT <br />
      EXCITING ANY MORE?
    </p>
  ),
  JoinAsInvestor: `JOIN AS BETA`,
  InvestTimeSkillsAndNetworkIntoProjects: (
    <p className="slide-font-style-2" style={{ textAlign: 'left' }}>
      <span className="slide-font-style-3">Invest time, skills and network into projects</span> <br /> tackling problems close to your heart
      and <br /> build your own <span className="slide-font-style-3">portfolio of startups.</span>
    </p>
  ),

  AccessToTheStartupEcosystemIsMinutesAway: (
    <p className="slide-font-style-1" style={{ textAlign: 'right' }}>
      ACCESS TO THE <br /> STARTUP ECOSYSTEM <br /> IS MINUTES AWAY
    </p>
  ),
  BecomeAPartner: <p className="slide-font-style-1">BECOME A PARTNER</p>,
  AndBoostYourSalesByProvidingYourServicesToStartups: (
    <p className="slide-font-style-2" style={{ textAlign: 'left' }}>
      and boost your sales by <br /> providing your services <br /> to startups
    </p>
  ),

  JoinAsAnArray: `JOIN AS AN ARRAY`,
  ManageYourFoundersAndProjectsProtfolioWithBETA100: `Manage your founders and projects portfolio with BETA100`,

  // ReactScriptTag: `(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:3093060,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')`,
  ReactScriptTag: `(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:3156893,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
  NotificationTimerMs: 60000, // 1 min

  LogOutMessage: `Do you really want to logout?`,
  AreYouSureYouWantToDeleteThisPersona: `Are you sure you want to delete this persona?`,
  FounderProfileDeleteMessage: `Do you really want to delete Founder profile?`,
  BetaProfileDeleteMessage: `Do you really want to delete BETA profile?`,
  PartnerProfileDeleteMessage: `Do you really want to delete Partner profile?`,
  ScheduleDeleteConfirmationHeading: `Are you sure you wish to delete this meeting? If so, the message below will be sent to the BETA.`,
  ShareYourMeetingExperience: 'Share your meeting experience!',
  BETAProjects: 'BETA Projects',
  FounderProjects: 'Founder Projects',
  YourMeetingHasBeenScheduled: 'Your meeting has been scheduled!',
  OfferDeleteConfirmationHeading: `Are you sure you wish to delete this offer ?`,
  SocialLoginHeading: `We need you to provide email id same as what you have used for social login. Also this has to be validated once with the otp. This email will be used for email correspondence.`,
  ChatWelcomeMessage: 'Welcome to BETA 100',

  PleaseEnterTheCouponCode: 'Please enter the coupon code!',
  ViewExistingFile: 'View existing file',
  InvalidPanel: 'Select a valid panel',

  bgvStatusValues: [
    { label: 'Unable To Verify', value: 'UnableToVerify' },
    { label: 'Discrepancy', value: 'Discrepancy' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Insufficient', value: 'Insufficient' }
  ],

  foundNotFound: [
    { label: 'Found', value: 'found' },
    { label: 'Not Found', value: 'notFound' }
  ]
};

export const QcNaming = {
  AdditionalComment: 'Additional Comment',
  EligibleForRehire: 'Eligible For Rehire',
  VerificationStatus: 'Verification Status',
  GoogleVerificationStatus: 'Google Verification Status',
  McaVerificationStatus: 'MCA Verification Status',
  NasscomVerificationStatus: 'NASSCOM Verification Status',
  NseVerificationStatus: 'NSE Verification Status',
  BseVerificationStatus: 'BSE Verification Status',
  AuthenticatedBy: 'Authenticated By',
  ContactDetails: 'Contact Details',
  ModeOfVerification: 'Mode Of Verification',
  TypeOfVerification: 'Type Of Verification',
  DateVerified: 'Date Verified'
};

export const componentsListArray = [
  'Education',
  'Address',
  'CompanyCheck',
  'Criminal',
  'CreditCheck',
  'CibilCheck',
  'CvValidation',
  'DatabaseCheck',
  'DirectorshipCheck',
  'DrugTest',
  'Employment',
  'GapVerification',
  'Identification',
  'PoliceVerification',
  'Reference',
  'SocialMedia'
];

export const EmailInitiation = {
  EmailsRequired: 'Recipients are required!'
};

export const userRolesArray = ["Teachers", "Students", "Parents", "Admins"];

export const AddSection = {

  SectionTitleRequired: 'Section name is required!',
  QuizMinutesRequired: 'Quiz Minutes are required!',
  TopictitleTooShort: 'Topic Title is too short!',
  TopictitleTooLong: "Topic Title is too long!",
  DescriptionRequired: " Topic Description is required!"
};

export const AddAdminEmail = {
  AdminEmailRequired: 'Admin email required!',
  AdminEmailTooShort: 'Admin email is too short!',
  AdminEmailTooLong: "Admin email is too long!",
  InvalidEmailFormat: "Invalid email format."

};

export const FocusAreaColumn = {
  column: [
    {
      Header: 'Concepts',
      accessor: 'concepts',
    },
    {
      Header: '% understood',
      accessor: 'understood',
    },
    {
      Header: '% not understood',
      accessor: 'notUnderstood',
    },
  ],
  data: [
    { concepts: 'Forces', understood: ' 53%', notUnderstood: '46%'},
    { concepts: 'Density of forces', understood: '90%', notUnderstood: '10%' },
    { concepts: 'Pressure', understood: '89%', notUnderstood: '11%'},
  ]
};

export const CognitiveSkillsColumn ={ 
  column: [
  {
    Header: 'Skill',
    accessor: 'skill',
  },
  {
    Header: 'No. of Questions',
    accessor: 'noOfQuestions',
  },
  {
    Header: 'Average Percentage',
    accessor: 'averagePercentage',
  },
],
  data: [
    { skill: 'Remembering', noOfQuestions: '3', averagePercentage: '41%' },
    { skill: 'Understanding', noOfQuestions: '2', averagePercentage: '48%' },
    { skill: 'Evaluating', noOfQuestions: '1', averagePercentage: '40%' },
  ]
};

export const LevelOfDifficultyColumn = {
  column: [
  {
    Header: 'Level of Difficulty',
    accessor: 'level',
  },
  {
    Header: 'No. of Questions',
    accessor: 'noOfQuestions',
  },
  {
    Header: 'Average Percentage',
    accessor: 'averagePercentage',
  },
],
data: [
  { levelOfDifficulty: 'Easy', noOfQuestions: '3', averagePercentage: '41%' },
  { levelOfDifficulty: 'Medium', noOfQuestions: '2', averagePercentage: '48%' },
  { levelOfDifficulty: 'Hard', noOfQuestions: '1', averagePercentage: '40%' },
]
};

export const SessionStorageKeys = {
  SessionToken: "user_jwt",
  UserRole: "UserRole",
  Role:"role",
  SchoolId:"school_id",
  SchoolName:"school_name",
  TeacherId:"teacher_id"
}